/* Carousel */
// Uses Gallery card in Ghost editor w/ .carousel-captions
// Used with styling in carousel.scss

const carousel = function(documentElem) {
  let slides = []; // 2D array of img-# and caption-# ids
  let slideNum = 0;

  function galleryToCarousel() {
    let carousel = documentElem.querySelectorAll('.carousel');
    if (!carousel.length) return;

    carousel = carousel[0]; // Only one active carousel instance per page
    carousel.id = "activeCarousel";

    let images = documentElem.querySelectorAll(
      '.carousel .kg-gallery-image img'
    );

    images.forEach((image, index) => {
      var container = image.closest('.kg-gallery-image');
      // add carousel-img class & img-# id to each img wrapper for styling
      container.classList.add("carousel-img");
      container.id = "img-" + index;
      // removes inline flex from resizeImagesInGalleries:
      container.style.removeProperty('flex');
      slides[index] = [];
      slides[index][0] = container.id;
    });

    let captions = documentElem.querySelectorAll('.carousel-captions ol > li');
    captions.forEach((caption, index) => {
      caption.id = "cap-" + index;
      if (slides[index]) { // only add caption if corresponding image
        slides[index][1] = caption.id;
      }
    });
  }

  function hideSlide(num) {
    let currImg = documentElem.getElementById(slides[num][0]);
    let currCap = documentElem.getElementById(slides[num][1]);
    currImg.style.display = "none";
    currCap.style.display = "none";
    currImg.style.opacity = 0;
    currCap.style.opacity = 0;
  }

  function showSlide(num) {
    let nextImg = documentElem.getElementById(slides[num][0]);
    let nextCap = documentElem.getElementById(slides[num][1]);
    nextImg.style.display = "block";
    nextCap.style.display = "block";
    nextImg.style.opacity = 1;
    nextCap.style.opacity = 1;
  }

  function initCarousel() {
    galleryToCarousel();

    if (slides.length > 1) {
      let activeCarousel = documentElem.getElementById('activeCarousel');
      activeCarousel.addEventListener('click', function() {
        hideSlide(slideNum);
        slideNum++;
        if (slideNum > slides.length - 1) {
          slideNum = 0;
        }
        showSlide(slideNum);
      });
    }

    // TO-DO: add arrows/arrow key sliding functionality, timed transitions

  }

  return {
    init: initCarousel
  }
}
